import { types } from 'mobx-state-tree';

const DataType = types
  .model('DataType', {
    id: types.identifier,
    name: types.string,
    category: types.string,
  })
  .actions(() => ({})) // eslint-disable-line no-unused-vars
  .views(() => ({})); // eslint-disable-line no-unused-vars

export { DataType };
